var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgGbModal = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 60,
    viewBox: "0 0 80 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2095_3434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H80V60H0V0Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.375 0L39.875 22.625L70.25 0H80V7.75L50 30.125L80 52.375V60H70L40 37.625L10.125 60H0V52.5L29.875 30.25L0 8V0H9.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 35.125L80 55V60L46.125 35.125H53ZM30 37.625L30.75 42L6.75 60H0L30 37.625ZM80 0V0.375L48.875 23.875L49.125 18.375L73.75 0H80ZM0 0L29.875 22H22.375L0 5.25V0Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.125 0V60H50.125V0H30.125ZM0 20V40H80V20H0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 24.125V36.125H80V24.125H0ZM34.125 0V60H46.125V0H34.125Z",
    fill: "#C8102E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2095_3434"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 60,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGbModal, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/GBModal.0fb88a6b.svg";
export { ForwardRef as ReactComponent };